<script setup lang="ts">
import { ref } from 'vue'
import UiFieldContainer from './UiFieldContainer.vue'
import { Field } from '@ark-ui/vue'

export interface UiTextareaProps {
  name?: string
  id?: string
  placeholder?: string
  rows?: number
  disabled?: boolean
  readonly?: boolean
  size?: 'md' | 'lg'
  hint?: string
  error?: string
  invalid?: boolean
  ariaLabel?: string
}

const props = withDefaults(defineProps<UiTextareaProps>(), {
  rows: 4,
  size: 'md',
})

const model = defineModel<string>({ default: '' })
const isFocused = ref(false)

const emit = defineEmits<{
  (e: 'validate'): void
}>()
</script>

<template>
  <UiFieldContainer :size="props.size" flexable :invalid="props.invalid" :hint="props.hint" :error="props.error" :describedByIdBase="props.id || props.name" :disabled="props.disabled">
    <Field.Root class="w-full">
        <Field.Textarea
            class="flex-1 w-full se-font-input font-archivo focus:outline-none py-2"
            :rows="props.rows"
            :id="props.id || props.name"
            :name="props.name"
            v-model="model"
            :placeholder="props.placeholder"
            :disabled="props.disabled"
            :readonly="props.readonly"
            @focus="isFocused = true"
            @blur="isFocused = false; emit('validate')"
            :aria-invalid="props.invalid ? 'true' : undefined"
            :aria-label="props.ariaLabel"
            :aria-describedby="props.error ? (props.id || props.name) + '-error' : (props.hint ? (props.id || props.name) + '-hint' : undefined)"
        />
    </Field.Root>
  </UiFieldContainer>
</template>
